(function() {
  const selectors = {
    notifyMeHandler: '.js-notify-me',
    notifyMePopupToggler: '.js-toggle-notify-me',
    overflowBlock: '.overflowBlock',
    selectedSwatch: '.selected-swatch',
    notifyMeInput: '.notify-me__input',
    notifyMeErros: '.notify-me__error',
    popupWrapper: '.notify-me__popup-wrapper',
    activeInput: '.product__swatchesItem input:checked',
    productInfo: '.product .product__wrapper .product__info',
    body: 'body',

    overflowBlockHiddenClass: 'overflowBlock--hidden',
    notifyMeActiveClass: 'notify-me__error--active',
    popupWrapperActiveClass: 'notify-me__popup-wrapper--active',
    bodyOverflowClass: 'body--overflow',
    popupWrapperSuccessClass: 'notify-me__popup-wrapper--success',
    productInfoNotifyMeActiveClass: 'product__info--notify-me-active'
  };
  const notifyMeHandler = document.querySelector(selectors.notifyMeHandler);
  const notifyMePopupToggler = document.querySelectorAll(selectors.notifyMePopupToggler);

  async function addNotifyProduct(e) {
    e.preventDefault();

    const targetData = e.currentTarget.dataset;
    const selectedSwatch = document.querySelector(selectors.selectedSwatch);
    const activeInput = document.querySelector(selectors.activeInput);
    const { handle, title, id } = targetData;
    const currentVariantTitle = selectedSwatch?.querySelector('input')?.value || activeInput.dataset.variantId;
    const currentVariantID = window.location.href.split('=')[1];
    const notifyMeInput = document.querySelector(selectors.notifyMeInput);
    const notifyMeErros = document.querySelector(selectors.notifyMeErros);
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const notifyData = {
      "action": "notifyCustomer",
      "shop": "koio-collective.myshopify.com",
      "product_handle": handle,
      "product_id": +id,
      "product_title": title,
      "variant_id": +currentVariantID,
      "variant_title": currentVariantTitle,
      "email": notifyMeInput.value,
    };

    if (!emailPattern.test(notifyMeInput.value)) {
      notifyMeErros.innerHTML = 'Please enter a valid email address';
      notifyMeErros.classList.add(selectors.notifyMeActiveClass);
      notifyMeErros.style.height = `${notifyMeErros.scrollHeight}px`;

      setTimeout(() => {
        notifyMeErros.classList.remove(selectors.notifyMeActiveClass);
        notifyMeErros.style.height = `0px`;
      }, 3000);

      return null;
    }

    try {
      const response = await fetch('https://www.koio.co/apps/ctstock', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(notifyData),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const popupWrapper = document.querySelector(selectors.popupWrapper);

      popupWrapper.classList.add(selectors.popupWrapperSuccessClass);
    } catch (error) {
      console.error(error);
    }
  }

  function togglePopup() {
    const popupWrapper = document.querySelector(selectors.popupWrapper);
    const body = document.querySelector(selectors.body);
    const productInfo = document.querySelector(selectors.productInfo);

    productInfo?.classList.toggle(selectors.productInfoNotifyMeActiveClass);
    popupWrapper.classList.toggle(selectors.popupWrapperActiveClass);
    body.classList.toggle(selectors.bodyOverflowClass);
    popupWrapper.classList.remove(selectors.popupWrapperSuccessClass);
  }

  notifyMeHandler.addEventListener('click', addNotifyProduct);

  notifyMePopupToggler.forEach((handler) => {
    handler.addEventListener('click', togglePopup);
  });
})();
